import { render, staticRenderFns } from "./Depth1.vue?vue&type=template&id=d7619f04&scoped=true&"
import script from "./Depth1.vue?vue&type=script&lang=js&"
export * from "./Depth1.vue?vue&type=script&lang=js&"
import style0 from "./Depth1.vue?vue&type=style&index=0&id=d7619f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7619f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7619f04')) {
      api.createRecord('d7619f04', component.options)
    } else {
      api.reload('d7619f04', component.options)
    }
    module.hot.accept("./Depth1.vue?vue&type=template&id=d7619f04&scoped=true&", function () {
      api.rerender('d7619f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vendors/Terms/Depth1.vue"
export default component.exports